/**
 * "Once per browser tab" guards, kept in `sessionStorage`. Storage can throw
 * (blocked site data, full quota), so a key that cannot be stored is kept in
 * memory instead: the guard then holds until the next page load.
 *
 * Keys get an `analytics:` prefix, so they cannot collide with other
 * `sessionStorage` keys.
 */
const KEY_PREFIX = "analytics:";

const firedInMemory = new Set<string>();

export function hasFired(event: string): boolean {
  if (firedInMemory.has(event)) return true;
  try {
    return window.sessionStorage.getItem(KEY_PREFIX + event) !== null;
  } catch {
    return false;
  }
}

export function markFired(event: string): void {
  try {
    window.sessionStorage.setItem(KEY_PREFIX + event, "1");
  } catch {
    firedInMemory.add(event);
  }
}
